const WinlosesTypes = {
    FETCH_START:    '[MUSIC] FETCH START',
    FETCH_SUCCESS:  '[MUSIC] FETCH SUCCESS',
    FETCH_FAILURE:  '[MUSIC] FETCH FAILURE'
};

export default WinlosesTypes;